import styled from '@emotion/styled';

export const PageContent = styled.div`
  padding: 10px;
`;
